/**
 * Provides progress report type to use in progress report forms.
 */
export enum ProgressReportType {
  ClassOverTime = 'Class Over Time',
  IndividualStudentOverTime = 'Individual Student Over Time',
  ClassSpread = 'Class Spread',
  ClassSkillsHeatmap = 'Class Skills Heatmap',
  StandardsDetail = 'Standards Detail',
  StandardsOverTime = 'Standards Over Time',
  SkillAverages = 'Skill Averages',
}

/**
 * Enables query param for report type to always have the correct report selected.
 *
 * This allows the display text of the dropdown to change w/out impacting existing bookmarks.
 */
export enum ProgressReportQueryParamByType {
  ClassOverTime ='class-over-time',
  IndividualStudentOverTime = 'student-over-time',
  ClassSpread = 'class-spread',
  ClassSkillsHeatmap = 'class-skills-heatmap',
  StandardsDetail = 'standards-detail',
  StandardsOverTime = 'standards-over-time',
  SkillAverages = 'skill-averages',
}

export class ProgressReportTypeModel {
  type: ProgressReportType = undefined;
  queryParam: ProgressReportQueryParamByType = undefined;
  isPrinting: boolean = false;
  isExporting: boolean = false;
}

const progressReportQueryParamByTypeReverseMap = Object.fromEntries(
  Object.entries(ProgressReportQueryParamByType).map(([key, value]) => [value, key])
);

export function getReportTypeFromQueryParam(queryParam: ProgressReportQueryParamByType): ProgressReportType {
  return ProgressReportType[progressReportQueryParamByTypeReverseMap[queryParam]];
}
